import { render, staticRenderFns } from "./LegalBeneficiaryForm.vue?vue&type=template&id=38975766&"
import script from "./LegalBeneficiaryForm.vue?vue&type=script&lang=js&"
export * from "./LegalBeneficiaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports